<div class="confirm-action">
  <button
    type="button"
    class="confirm-action__close"
    aria-label="Close"
    [mat-dialog-close]="false"
  >
    <svg-icon
      class="confirm-action__close-icon"
      src="/assets/icons/close-modal.svg"
      [svgStyle]="{ 'width.rem': 0.5, 'height.rem': 0.5 }"
    ></svg-icon>
  </button>

  <div class="confirm-action__title">{{ data.title | translate }}</div>

  <button
    type="button"
    class="confirm-action__confirm"
    [ngClass]="'confirm-action__confirm--' + (data.variant || 'primary')"
    [mat-dialog-close]="true"
  >
    {{ data.confirmLabel | translate }}
  </button>

  @if (data.description) {
    <div class="confirm-action__description">{{ data.description | translate }}</div>
  }
</div>
